import { Prisma } from "@prisma/client";

//#region src/modelTypes.ts
const LLMModelDBData = Prisma.validator()({ include: { supportsFileTypes: true } });
const LLM_PROFILE_SERVICE_IDENT = "org.greenhouse.modules.LLMProfileService";
const RPC_EVENT_PROFILE_CREATED_IDENT = "org.aimystic.modules.events.ProfileCreated";
const RPC_EVENT_PROFILE_UPDATED_IDENT = "org.aimystic.modules.events.ProfileUpdated";
const RPC_EVENT_PROFILE_DELETED_IDENT = "org.aimystic.modules.events.ProfileDeleted";
const RPC_EVENT_PROFILE_CREATED = {
	ident: RPC_EVENT_PROFILE_CREATED_IDENT,
	description: "Event emitted when an LLM profile is created",
	params: [{
		name: "profile",
		type: "object",
		description: "The profile that was created"
	}]
};
const RPC_EVENT_PROFILE_UPDATED = {
	ident: RPC_EVENT_PROFILE_UPDATED_IDENT,
	description: "Event emitted when an LLM profile is updated",
	params: [{
		name: "profile",
		type: "object",
		description: "The profile that was updated"
	}]
};
const RPC_EVENT_PROFILE_DELETED = {
	ident: RPC_EVENT_PROFILE_DELETED_IDENT,
	description: "Event emitted when an LLM profile is deleted",
	params: [{
		name: "profileId",
		type: "string",
		description: "The ID of the profile that was deleted"
	}]
};

//#endregion
export { LLMModelDBData, LLM_PROFILE_SERVICE_IDENT, RPC_EVENT_PROFILE_CREATED, RPC_EVENT_PROFILE_CREATED_IDENT, RPC_EVENT_PROFILE_DELETED, RPC_EVENT_PROFILE_DELETED_IDENT, RPC_EVENT_PROFILE_UPDATED, RPC_EVENT_PROFILE_UPDATED_IDENT };
//# sourceMappingURL=modelTypes.js.map